var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_142",
    transform: "scale(0.00378788)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_142",
    width: 264,
    height: 264,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAAEIAQMAAACZOPi8AAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA4UlEQVRoge2VQRYCMQhDuf+l0WkSBmtno8sQ+yqWv8qDGDEajUZ/KKF3cZ1V6MWTqHs9X6e9OxKrwXv9rtqZiBqaIeRVcLW8Cd6ruHu2BPO1fR4y2YNoZOA8yYNAR30FTRoT+AoRh41yIsq3BI7qe6NciDYwbOdmmBfRhoc04jdNCY4Lxia4Ufmxc1aE5oZenXbOiqhhkXXlmSehNaJXCUXYEuVcD5k4QB6ELNIcMW59Cd7otH8iW4K5Us7tG+VJVMwCsicQLYyZ0GQ5EuTQroQJV+LeJCXtFjJexGg0Gv2gFzqW7pChn4VgAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.dad107ab32e6d9a4b281fd4e4973141e.svg";
export { ForwardRef as ReactComponent };